import { SystemIcon } from "@justworkshr/milo-icons";
import { Button } from "@justworkshr/milo-core";
import { UserMenuMemberWithCompany } from "types";
import styles from "./user-menu-drawer-content.module.css";
import { buildWebPath } from "lib/resource-finder";
import { usePanelsControlContext } from "app-frame/header/context/panels-control-context-provider";
import { PanelsControlActionType } from "app-frame/header/context/panels-control-context-provider/types";
import { useGetHelpMenuQuery } from "types/generated/operations";

const { listItems } = styles;

interface UserMenuDrawerContentProps {
  hasAccessToAlerts: boolean;
  hasAccessToWhatsNew: boolean;
  otherCompaniesOfCurrentUser: UserMenuMemberWithCompany[];
}

function UserMenuDrawerContent({
  hasAccessToAlerts,
  hasAccessToWhatsNew,
  otherCompaniesOfCurrentUser,
}: UserMenuDrawerContentProps) {
  const { dispatch } = usePanelsControlContext();

  const { data, loading } = useGetHelpMenuQuery();
  if (loading || !data) {
    return <></>;
  }
  const hasAccessToAdvancedHelp =
    data.authenticatedMember.capabilities.hasAccessToAdvancedHelpChat;

  const handleHelpButtonOnClick = () => {
    if (hasAccessToAdvancedHelp) {
      dispatch({ type: PanelsControlActionType.OPEN_ADVANCED_HELP_DRAWER });
    } else if (window.Forethought) {
      dispatch({ type: PanelsControlActionType.OPEN_FORETHOUGHT_HELP_CHAT });
      window.Forethought("widget", "open");
    }
  };

  const alertsButton = (
    <Button
      variant="ghost"
      onClick={() =>
        dispatch({
          type: PanelsControlActionType.OPEN_ALERTS_DRAWER,
        })
      }
    >
      <SystemIcon iconName="bell" color="brand" size="small" />
      Alerts
    </Button>
  );

  const whatsNewButton = (
    <Button
      variant="ghost"
      onClick={() =>
        dispatch({
          type: PanelsControlActionType.OPEN_WHATS_NEW_DRAWER,
        })
      }
    >
      <SystemIcon iconName="whats-new" color="brand" size="small" />
      What's new
    </Button>
  );

  const helpButton = (
    <Button variant="ghost" onClick={handleHelpButtonOnClick}>
      <SystemIcon iconName="help" color="brand" size="small" />
      Help
    </Button>
  );

  const switchCompaniesButton = (
    <Button
      variant="ghost"
      onClick={() =>
        dispatch({
          type: PanelsControlActionType.OPEN_SWITCH_COMPANIES_DRAWER,
        })
      }
    >
      <SystemIcon iconName="building" color="brand" size="small" />
      Switch companies
    </Button>
  );

  const logoutButton = (
    <Button variant="ghost" as="a" href={buildWebPath("/logout")}>
      <SystemIcon iconName="logout" color="brand" size="small" />
      Log out
    </Button>
  );

  const items: JSX.Element[] = [];
  if (hasAccessToAlerts) {
    items.push(alertsButton);
  }
  if (hasAccessToWhatsNew) {
    items.push(whatsNewButton);
  }
  items.push(helpButton);
  if (otherCompaniesOfCurrentUser && otherCompaniesOfCurrentUser.length >= 1) {
    items.push(switchCompaniesButton);
  }
  items.push(logoutButton);

  return (
    <ul className={listItems}>
      {items.map((item, index) => {
        return <li key={`user-nav-item-${index}`}>{item}</li>;
      })}
    </ul>
  );
}

export default UserMenuDrawerContent;
